export default __webpack_public_path__ + "static/media/uploadFile.8d88b606.png";